import { render } from "./InfoCidiComponent.vue?vue&type=template&id=69a324c8&scoped=true"
import script from "./InfoCidiComponent.vue?vue&type=script&lang=js"
export * from "./InfoCidiComponent.vue?vue&type=script&lang=js"

import "./InfoCidiComponent.vue?vue&type=style&index=0&id=69a324c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a324c8"]])

export default __exports__